module.exports = __webpack_public_path__ + "components/nearby-points/static/photo-5-a39e9eb059ae1c12ab48b79cbffaa4e6.jpg";